import styles from './CreatePost.module.css';
import { IconButton } from './IconButton';
import { IconPen } from './QuirkIcons';
import { usePostCreateActionSheet } from '../hooks/usePostCreateActionSheet';

export const CreatePost = ({ label }: { label?: string }) => {
	const presentPostCreateOptions = usePostCreateActionSheet();
	return (
		<>
			<div className={styles.container}>
				<IconButton
					label={label || 'Create new...'}
					onClick={presentPostCreateOptions}
					icon={
						<span className="iconCircle">
							<IconPen />
						</span>
					}
				/>
			</div>
			<hr />
		</>
	);
};
